const ENProjectSprint = {
	"Adicionar Sprint": "Add Sprint",
	"Alterar Sprint": "Change Sprint",
	"Erro ao adicionar sprint": "Error adding sprint",
	"Erro ao alterar sprint": "Error changing sprint",
	"Sprint adicionada com sucesso": "Sprint successfully added",
	"Sprint alterada com sucesso": "Successfully changed sprint"
};

export default ENProjectSprint;
